import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Island from "./components/Island";
import Experiences from "./components/Experiences";
import Guide from "./components/Guide";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Film from "./components/Film";
import { Toaster } from "./components/ui/toaster";

// Scrolls to top on route change, or to the hash target if one is present.
const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // wait a tick for the target section to mount
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 60);
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0 });
  }, [pathname, hash]);
  return null;
};

const Landing = () => (
  <div className="App">
    <Navbar />
    <main>
      <Hero />
      <Film />
      <Island />
      <Experiences />
      <Guide />
      <Contact />
    </main>
    <Footer />
    <Toaster />
  </div>
);

const DiyGuidePage = () => (
  <div className="App">
    <Navbar />
    <main>
      <Guide />
    </main>
    <Footer />
    <Toaster />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/diy-guide" element={<DiyGuidePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
